// Feature 009 — fixed role enumeration from the backend user_roles table.
// Feature 025 added 'Super Editor': an Editor with the extra power to flag hands for Jeff and
// record his commentary. Deliberately above Admin for that one job — Admin owns accounts, not
// bidding content — so the Ask Jeff surfaces check for this role and NOT for Admin.
export type UserRoleName = 'Admin' | 'Editor' | 'Public User' | 'Super Editor';

/** True for the roles that hold data-editing feature grants (Editor and Super Editor). */
export function isEditorRole(role: UserRoleName | undefined): boolean {
  return role === 'Editor' || role === 'Super Editor';
}

// Feature 011 — rich-object feature catalog entry (FR-016).
export interface FeatureCatalogEntry {
  code: string;
  displayName: string;
  description: string | null;
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: string;
  // Backend always returns one of the three UserRoleName values (FR-001).
  role: UserRoleName;
  // Feature 011 — true while the user owes a first-login password change.
  mustChangePassword: boolean;
}

export interface AuthUser extends User {
  // Feature 011 — rich-object catalog slice the caller can access.
  accessibleFeatures: FeatureCatalogEntry[];
}

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  user: User;
  // Feature 011 (FR-015) — rich-object accessible features.
  accessibleFeatures: FeatureCatalogEntry[];
}

export interface UpdateUserRequest {
  firstName?: string;
  lastName?: string;
  currentPassword?: string;
  newPassword?: string;
}

export interface ApiError {
  error: {
    message: string;
    statusCode: number;
  };
}

export interface ValidationError {
  title?: string;
  status?: number;
  errors?: Record<string, string[]>;
}
